






























import Posts from '../assets/posts/posts.json'

type PostMeta = { title: string, file: string}
type Data = { posts : PostMeta[] }

export default {
  name: 'Blog',
  data() : Data {
    return { 
      posts : Posts.posts
    }
  },
  methods: {
    blogRoute(f:string) : string {
      return `/blog/${f}`
    }
  }
}

